import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
/** Reporter (student/professor): my own incidents. */
export function useMyTickets() {
    return useQuery({
        queryKey: ['support', 'mine'],
        queryFn: () => apiClient('/support/tickets/mine'),
        staleTime: 1000 * 30,
    });
}
/** A ticket + its full thread. Opening it marks the counterparty's messages read. */
export function useSupportThread(ticketId) {
    return useQuery({
        queryKey: ['support', 'thread', ticketId],
        queryFn: () => apiClient(`/support/tickets/${ticketId}`),
        enabled: Boolean(ticketId),
    });
}
export function useCreateTicket() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/support/tickets', { method: 'POST', body: JSON.stringify(dto) }),
        onSuccess: () => void qc.invalidateQueries({ queryKey: ['support', 'mine'] }),
    });
}
/** Support console: every incident, optionally filtered by status. */
export function useAllTickets(status) {
    return useQuery({
        queryKey: ['support', 'all', status ?? 'all'],
        queryFn: () => apiClient(`/support/tickets${status ? `?status=${status}` : ''}`),
        staleTime: 1000 * 20,
    });
}
/** Support console: open/close a ticket. */
export function useUpdateTicketStatus(ticketId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (status) => apiClient(`/support/tickets/${ticketId}/status`, { method: 'PATCH', body: JSON.stringify({ status }) }),
        onSuccess: () => {
            void qc.invalidateQueries({ queryKey: ['support', 'all'] });
            void qc.invalidateQueries({ queryKey: ['support', 'thread', ticketId] });
        },
    });
}
export function usePostMessage(ticketId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient(`/support/tickets/${ticketId}/messages`, {
            method: 'POST',
            body: JSON.stringify(dto),
        }),
        onSuccess: () => {
            void qc.invalidateQueries({ queryKey: ['support', 'thread', ticketId] });
            void qc.invalidateQueries({ queryKey: ['support', 'mine'] });
        },
    });
}
//# sourceMappingURL=useSupport.js.map